// Watch every Freeform form for success/error banners appearing and keep them
// visible for 5 seconds. Freeform 5 injects these dynamically AND hides them
// after ~2s via inline style — we need to hold them visible for longer.
(function () {
    var MESSAGE_DURATION = 5000;
    var SELECTORS = ['.freeform-form-success', '.freeform-form-errors'];

    function observeForm(form) {
        var visibleUntil = 0;
        var resetting = false;

        function endShow() {
            resetting = true;
            visibleUntil = 0;
            form.removeAttribute('data-form-feedback-shown');
            SELECTORS.forEach(function (sel) {
                var el = form.querySelector(sel);
                if (el) el.style.display = 'none';
            });
            setTimeout(function () { resetting = false; }, 150);
        }

        function startShow(el) {
            el.style.display = 'block';
            form.setAttribute('data-form-feedback-shown', '');
            visibleUntil = Date.now() + MESSAGE_DURATION;
            setTimeout(endShow, MESSAGE_DURATION);
        }

        function handle() {
            if (resetting) return;

            SELECTORS.forEach(function (sel) {
                var el = form.querySelector(sel);
                if (!el || !el.innerText.trim()) return;

                var now = Date.now();
                var hidden = getComputedStyle(el).display === 'none';

                if (!hidden) {
                    // Already visible — start our window if not already running
                    if (visibleUntil === 0) startShow(el);
                    return;
                }

                if (now < visibleUntil) {
                    // Freeform hid it within our window — restore
                    el.style.display = 'block';
                    form.setAttribute('data-form-feedback-shown', '');
                } else if (visibleUntil === 0) {
                    // Fresh message — show it
                    startShow(el);
                }
                // visibleUntil > 0 but now >= visibleUntil: timer ended, ignore
            });
        }

        var observer = new MutationObserver(handle);
        observer.observe(form, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['style'],
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            document.querySelectorAll('[data-freeform]').forEach(observeForm);
        });
    } else {
        document.querySelectorAll('[data-freeform]').forEach(observeForm);
    }
}());

$(document).ready(function() {
    let forms = $('form');
    function gtmPush(event, formId) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: event,
                formName: formId
            });
        }
    }

    function checkGA() {
        if (typeof ga === 'function') {
            gtmSetup();
        } else {
            setTimeout(checkGA, 3000);
        }
    }

    function gtmSetup() {
        if (forms) {
            forms.each(function (position, $form) {
                let freeform = $form.freeform;
                if (freeform) {
                    ga(function () {
                        var tracker = ga.getAll()[0];

                        if (freeform.form.GATRACKID !== undefined) {
                            freeform.form.GACLIENTID.value = tracker.get('clientId');
                            freeform.form.GAUSERID.value = tracker.get('userId');
                            freeform.form.GATRACKID.value = tracker.get('trackingId');
                        }
                    });
                }
            });
        }
    }

    function setUtmValues(freeform, queryParams) {
        if ('utm_source' in queryParams) {
            Cookies.set('utm_source', queryParams['utm_source'][0], { expires: 1 });
        }
        if ('utm_medium' in queryParams) {
            Cookies.set('utm_medium', queryParams['utm_medium'][0], { expires: 1 });
        }
        if ('utm_campaign' in queryParams) {
            Cookies.set('utm_campaign', queryParams['utm_campaign'][0], { expires: 1 });
        }
        if ('utm_content' in queryParams) {
            Cookies.set('utm_content', queryParams['utm_content'][0], { expires: 1 });
        }

        if (freeform.form.utmSource !== undefined && Cookies.get('utm_source')) {
            freeform.form.utmSource.value = Cookies.get('utm_source');
        }

        if (freeform.form.utmMedium !== undefined && Cookies.get('utm_medium')) {
            freeform.form.utmMedium.value = Cookies.get('utm_medium');
        }

        if (freeform.form.utmCampaign !== undefined && Cookies.get('utm_campaign')) {
            freeform.form.utmCampaign.value = Cookies.get('utm_campaign');
        }

        if (freeform.form.utmContent !== undefined && Cookies.get('utm_content')) {
            freeform.form.utmContent.value = Cookies.get('utm_content');
        }

        if (freeform.form.state !== undefined && Cookies.get('location')) {
            freeform.form.state.value = Cookies.get('location').toUpperCase();
        }
    }

    function pageDetails(freeform) {
        if (freeform.form.pageUrl) {
            freeform.form.pageUrl.value = window.location;
        }
        if (freeform.form.pageTitle && freeform.form.dataset.pageTitle) {
            freeform.form.pageTitle.value = freeform.form.dataset.pageTitle
        }
    }

    function resetForm() {
        $('.freeform-column').each(function () {
            if ($(this)[0].hasAttribute('data-ff-rule')) {
                $(this).css('display', 'none');
            }
        });
    }

    function fadeOutNotifications() {
        setTimeout(function() {
            $('.ff-form-errors, .ff-form-success, .freeform-form-errors, .freeform-form-success').fadeOut();
        }, 5000);
        setTimeout(function() {
            $('.ff-errors').fadeOut();
        }, 15000);
    }

    function getUrlQueryParams() {
        var queryString = window.location.search || '';
        var keyValPairs = [];
        var params = {};
        queryString = queryString.substr(1);

        if (queryString.length) {
            keyValPairs = queryString.split('&');
            for (let pairNum in keyValPairs) {
                var key = keyValPairs[pairNum].split('=')[0];
                if (!key.length) {
                    continue;
                }
                if (typeof params[key] === 'undefined') {
                    params[key] = [];
                }
                params[key].push(keyValPairs[pairNum].split('=')[1]);
            }
        }

        return params;
    }

    function filterNonLatinCharacters(e) {
        const inputField = e.target;
        const cursorPos = inputField.selectionStart;
        const initialLength = inputField.value.length;
        const filtered = inputField.value.replace(/[^\x20-\x7F]+/g, "");
        const filteredLength = filtered.length;
        const numOfRemovedChars = initialLength - filteredLength;
        inputField.value = filtered;
        const currentCursorPos = cursorPos - numOfRemovedChars
        inputField.selectionStart = currentCursorPos;
        inputField.selectionEnd = currentCursorPos;
    }

    function setupInputFields() {
        const inputFields = document.querySelectorAll('input[type=text],textarea');
        inputFields?.forEach((inputField) => {
            inputField.addEventListener('input', filterNonLatinCharacters);
        });
    }

    function changePostcodeType(countryField) {
        const postcodeField = countryField.closest('form').querySelector('input[name="postcode"]');
        if (postcodeField) {
            const country = countryField.value;
            if (!country || country.trim().length === 0 || country === 'Australia') {
                postcodeField.type = 'number';
                postcodeField.removeEventListener('input', filterNonLatinCharacters);
            } else {
                postcodeField.type = 'text';
                postcodeField.addEventListener('input', filterNonLatinCharacters);
            }
        }
    }

    function changePostcodeTypeFromChangeEvent(e) {
        const countryField = e.target;
        changePostcodeType(countryField);
    }

    function setupCountryFields() {
        const countryFields = document.querySelectorAll('select[name="country"]');

        countryFields?.forEach((countryField) => {
            changePostcodeType(countryField);
        });

        countryFields?.forEach((countryField) => {
            countryField.addEventListener('change', changePostcodeTypeFromChangeEvent);
        });
    }


    // Freeform 5: per-form setup via freeform-ready (fires when each form initialises)
    document.addEventListener('freeform-ready', function(event) {
        const form = event.form;
        if (!form) return;

        const formId = form.id;
        const isDonationForm = formId ? formId.includes('donation') : false;
        const freeform = form.freeform;

        // Set UTM and page context into hidden fields
        if (freeform) {
            setUtmValues(freeform, getUrlQueryParams());
            pageDetails(freeform);
        }

        // Override Freeform's default banner messages
        if (isDonationForm) {
            event.options.successBannerMessage = 'Thank you! Your donation has been successfully processed. A confirmation email will be sent to you shortly.';
        } else {
            event.options.successBannerMessage = 'Thanks! Submission successful.';
        }
        event.options.errorBannerMessage = 'Error! Please try again.';

        // Fade out success/error banners after submission
        form.addEventListener('freeform-ajax-after-submit', () => {
            if (!isDonationForm) {
                fadeOutNotifications();
            }
        });

        // Analytics on success
        form.addEventListener('freeform-ajax-success', () => {
            resetForm();
            gtmPush('formSubmitted', formId);
        });
    });

    // Freeform 4 backward compatibility
    if (forms) {
        forms.each(function (position, $form) {
            let freeform = $form.freeform;

            if (freeform && typeof freeform.addOnAfterAjaxSubmit === 'function') {
                const formId = freeform.form.id;
                const isDonationForm = formId.includes('donation');

                setUtmValues(freeform, getUrlQueryParams());
                pageDetails(freeform);

                // Set via both Freeform 4 setOption and Freeform 5 data-attribute
                if (isDonationForm) {
                    freeform.setOption('successBannerMessage', 'Thank you! Your donation has been successfully processed. A confirmation email will be sent to you shortly.');
                    freeform.form.setAttribute('data-success-message', 'Thank you! Your donation has been successfully processed. A confirmation email will be sent to you shortly.');
                } else {
                    freeform.setOption('successBannerMessage', 'Thanks! Submission successful.');
                    freeform.form.setAttribute('data-success-message', 'Thanks! Submission successful.');
                }
                freeform.setOption('errorBannerMessage', 'Error! Please try again.');
                freeform.form.setAttribute('data-error-message', 'Error! Please try again.');

                // Prevent Freeform's default success handling for non-payment forms
                if (!isDonationForm) {
                    freeform.form.addEventListener('freeform-render-success', (e) => {
                        e.preventDefault();
                    });
                }

                freeform.addOnAfterAjaxSubmit((event, form, response) => {
                    // Support both Freeform 4 (.ff-) and Freeform 5 (.freeform-) class names
                    const $messages = $('#' + formId).find('.ff-form-errors, .ff-form-success, .freeform-form-errors, .freeform-form-success');
                    $messages.show();
                    const $buttonRow = $('#' + formId + ' button').closest('.freeform-row');
                    if ($buttonRow.length) {
                        $messages.insertAfter($buttonRow);
                    }
                    if (!isDonationForm) {
                        fadeOutNotifications();
                    }
                });

                freeform.addOnSuccessfulAjaxSubmit(function (event, form, response) {
                    resetForm();
                    gtmPush('formSubmitted', formId);
                });
            }
        });
    }

    checkGA();
    setupInputFields();
    setupCountryFields();
});
